import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { type CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { ZIndex } from '@ui/zIndexUtils';

const TOASTER_STYLE: CSSProperties & Record<`--${string}`, string> = {
  '--normal-bg': 'var(--popover)',
  '--normal-text': 'var(--popover-foreground)',
  '--normal-border': 'var(--border)',
  '--success-bg': 'var(--gain)',
  '--success-border': 'var(--gain)',
  '--success-text': 'var(--primary-foreground)',
  '--info-bg': 'var(--info)',
  '--info-border': 'var(--info)',
  '--info-text': 'var(--primary-foreground)',
  '--warning-bg': 'var(--warn)',
  '--warning-border': 'var(--warn)',
  '--warning-text': 'var(--primary-foreground)',
  '--error-bg': 'var(--destructive)',
  '--error-border': 'var(--destructive)',
  '--error-text': 'var(--primary-foreground)',
  '--border-radius': 'var(--radius)',
  fontFamily: 'var(--font)',
  zIndex: ZIndex.SNACKBAR,
};

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={TOASTER_STYLE}
      {...props}
    />
  );
};

export { Toaster };
